import React from "react";
import "./EndoresementContent.css";
import Container from "@material-ui/core/Container";

function EndoresementContent() {
  return (
    <>
      <div className="main-container" id='main'>
        <title>L&TT Portal - User Endorsements</title>
        {/* <img
          src="images/endorsements/at-new-endorsements-banner.jpg"
          alt="banner"
          className="endorsements-text-banner-img"
        /> */}
        <div className='bannerText-Wrapper'>
                <h1 className='bannerHeading' tabIndex={0}>Business and Learner <span>Endorsements</span></h1>
                <p className='bannerSubheading'>Appreciation from learning sponsors, champions, and enthisiastic participants for our path-breaking learning programs and offerings</p>
                </div>
      </div>
      <div className="banner-bar"></div>
      <div className="endorsements-container-bg">
        <Container className="endorsements-holder" maxWidth="xl">
          <div className="endorsements-container">
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>ATCI Song Townhall Videos</h2>
                <div className="endorsements-box">
                  <p>
                    We had 5500 people watching your work alongside Max Morielli
                    (President, Accenture Song Europe, who reports to David
                    Droga), and Mahesh Z. Hope you too could see and take pride.
                    It reflected that quality to be in that townhall. A great
                    communication capsule from ATCI that would help elevate the
                    stature of ATCI Song and ATCI overall. We will leverage it
                    for its relevant life. Very well done in the compressed
                    timelines you had – and thank you.{" "}
                  </p>
                  <h3>
                    Shridhar Rajgopalan,{" "}
                    <span className="lead-title">Managing Director</span>{" "}
                  </h3>
                  <img
                    src="images/endorsements/Shridhar-Rajgopalan.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>ATCI Song Townhall Videos</h2>
                <div className="endorsements-box">
                  <p>
                    It has been an absolute pleasure working with you over the
                    last three weeks. The two videos have come out very well and
                    will certainly be leveraged to give us the mileage we are
                    looking to gain through our ATCI-Song brand-building
                    efforts. Thanks to the entire team that helped pull this off
                    with quality in a short time.
                    <span style={{ visibility: "hidden" }}>
                      the stature of ATCI Song and ATCI overall. We will
                      leverage it for its relevant life. Very well done in the
                      compressed timelines you had – and thank you.
                    </span>{" "}
                  </p>
                  <h3>
                    Tej Kumar,{" "}
                    <span className="lead-title">Associate Director</span>
                  </h3>
                  <img
                    src="images/endorsements/Tej-Kumar.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row row5">
                <h2>URJa - NA Utilities Learning Symposium</h2>
                <div className="endorsements-box">
                  <p>
                    I’m so happy and proud of what our teams have achieved
                    together in the past few weeks! It’s a huge body of work
                    honed to perfection.
                  </p>
                  <h3>
                    Sonali Patke,{" "}
                    <span className="lead-title">Managing Director</span>
                  </h3>
                  <img
                    src="images/endorsements/Sonali-Patke.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>Accenture STEM Awareness</h2>
                <div className="endorsements-box">
                  <p>
                    "Thanks a lot for your rock-solid support for our first
                    launch on Maharani Kishori Devi School. L&TT has been a
                    strong pillar for running the program. Each one of you
                    played a pivotal role in this journey."
                  </p>
                  <h3>
                    Shalini Aggarwal,{" "}
                    <span className="lead-title">Managing Director</span>{" "}
                  </h3>
                  <img
                    src="images/endorsements/ShaliniAggarwal.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>DevOps - Consul</h2>
                <div className="endorsements-box">
                  <p>
                    "The team gained a good knowledge of both Vault and Consul
                    components of HashiCorp through learning and labs sessions."{" "}
                    <span style={{ visibility: "hidden" }}>
                      the program Each one of you played a pivotal role pivotal
                      role this journey
                    </span>{" "}
                  </p>
                  <h3>
                    {" "}
                    Singh, Avnish K.,{" "}
                    <span className="lead-title">
                      Security Delivery Manager
                    </span>
                  </h3>
                  <img
                    src="images/endorsements/AvnishKSingh.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>ASPIRA (Executive enablement program)</h2>
                <div className="endorsements-box">
                  <p>
                    The ASPIRA Specialization in Key Technologies for Business
                    has boosted my knowledge on cloud computing, data science,
                    and AI, and enabled me to appreciate their value in driving
                    business growth. The knowledge and insights I gained have
                    empowered me to have meaningful conversations with
                    stakeholders and clients on the Market -moving key
                    technologies of today. <br /> I thank the L&TT and the ASPIRA
                    teams for an excellent virtual learning opportunity.{" "}
                  </p>
                  <h3>
                    Mahesh Kelker,{" "}
                    <span className="lead-title">Managing Director</span>{" "}
                  </h3>
                  <img
                    src="images/endorsements/Mahesh-Kelker.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>ASPIRA (Executive enablement program)</h2>
                <div className="endorsements-box">
                  <p>
                    “ASPIRA is an Excellent Program for Executive by L&TT. It
                    gives the opportunity to gain Global certification and
                    Enhance Knowledge. It’s a self-paced, 100% online Platform
                    and provides lots of courses to choose from based on our
                    interests. It was very much engaging, and I recently
                    completed my Agile Leadership Specialization Certification
                    in a short span. I would like to take more courses to
                    enhance my skills and encourage all to complete the
                    specialization specific to the role they perform.”
                  </p>
                  <h3>
                    Rajesh Jagadeesan,{" "}
                    <span className="lead-title">Senior Manager</span>
                  </h3>
                  <img
                    src="images/endorsements/Rajesh-Jagadeesan.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>ASPIRA (Executive enablement program)</h2>
                <div className="endorsements-box">
                  <p>
                    As delivery lead I found this course very insightful and
                    practical, I intend to use my learnings in my day-to-day
                    interactions with clients, client teams, 3rd parties, and
                    teams within your own organization. The course teaches how
                    to tell a compelling story, build rapport, negotiation,
                    conflict resolution, manage change, risk governance and
                    manage the risks. These learnings continue to help me to
                    achieve the purpose and objectives of the organization by
                    engaging all the relevant stakeholders very effectively.{" "}
                    <br /> I would appreciate all the support and help from the
                    ASPIRA team in offering this course.
                    <span style={{ visibility: "hidden" }}>
                      The Capstone project which was a simulation of a real
                      situation was exciting and gave me a great experience. I
                      thoroughly enjoyed and request you all to complete yours.
                      I thoroughly enjoyed
                    </span>{" "}
                  </p>
                  <h3>
                    Raghavendra Murari,{" "}
                    <span className="lead-title">Associate Director</span>{" "}
                  </h3>
                  <img
                    src="images/endorsements/Raghavendra-Murari.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>ASPIRA (Executive enablement program)</h2>
                <div className="endorsements-box">
                  <p>
                    Thanks to ASPIRA framework for enabling us learn various
                    topics of interest. I recommend all to take the opportunity
                    we are offered. <br /> The ‘Executive Data Science’ course
                    consists of 4 courses and a capstone project. Very
                    informative sessions and plenty of reference materials in
                    case you want to go deep in an area. The course is paced out
                    well so one could get a hold on the topic even if you spend
                    a couple of hours on weekends. It is definitely a value add
                    as most of the projects we run today will have the
                    opportunity to apply what you learned during the course of
                    the project. The Capstone project which was a simulation of
                    a real situation was exciting and gave me a great
                    experience. I thoroughly enjoyed and request you all to
                    complete yours.
                    <span style={{ visibility: "hidden" }}>
                      I thoroughly enjoyed and request you all to complete
                      yours.
                    </span>
                  </p>
                  <h3>
                    Divya Parambath,{" "}
                    <span className="lead-title">Managing Director</span>
                  </h3>
                  <img
                    src="images/endorsements/Divya-Parambath.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>ASPIRA (Executive enablement program)</h2>
                <div className="endorsements-box">
                  <p>
                    "ASPIRA is a great way to learn and stay relevant to the
                    market and clients. Most of the courses are self-paced and
                    from reputed universities. I suggest everyone to take up
                    courses as per your liking – be it industry, technology or
                    management. This will enhance your knowledge and help you
                    stay relevant to clients and the market. On the personal
                    front, a big thanks to the L&TT team."
                  </p>
                  <h3>
                    Dinesh Mittal,{" "}
                    <span className="lead-title">Managing Director</span>
                  </h3>
                  <img
                    src="images/endorsements/DineshMittal.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>InnoSpark</h2>
                <div className="endorsements-box">
                  <p>
                    "L&TT Team has put special efforts to bring the best
                    experience to the participants in terms of gamification of
                    the program and making the program more interesting to the
                    team. A very Big Thanks to the L&TT team for making InnoSpark
                    a beautiful journey."{" "}
                    <span style={{ visibility: "hidden" }}>
                      was your knowledge and help you stay relevant to clients
                      and the market. On the personal front, a front, a big
                      thanks the L&TT team.
                    </span>{" "}
                  </p>
                  <h3>
                    Bhavani Somaraju,{" "}
                    <span className="lead-title">Managing Director</span>
                  </h3>
                  <img
                    src="images/endorsements/BhavaniSomaraju.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>SI Master Class (SIMC) for Delivery Leads</h2>
                <div className="endorsements-box">
                  <p>
                    "Experience sharing, simulation, and the case studies were
                    absolute Gold!"
                  </p>
                  <h3>
                    Ananya Ghosh,{" "}
                    <span className="lead-title">Associate Director</span>
                  </h3>
                  <img
                    src="images/endorsements/AnanyaGhosh.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>Value-Driven Client Conversations 4.0</h2>
                <div className="endorsements-box">
                  <p>
                    "This is an important learning program to be on the value
                    architecture path!"
                  </p>
                  <h3>
                    Aditi Kulkarni,{" "}
                    <span className="lead-title">Managing Director</span>
                  </h3>
                  <img
                    src="images/endorsements/AditiKulkarni.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row">
                <h2>Delivery Sales Academy</h2>
                <div className="endorsements-box">
                  <p>
                    "This has been a super wonderful experience. Really
                    well-thought workshop. The case study approach and putting
                    the participants into realistic situations led to good
                    learning. Will help me elevate my current work of pitching
                    to the client to win a sole-sourced extension and grab more
                    work. External and internal coaches were great and gave good
                    guidance."{" "}
                    <span style={{ visibility: "hidden" }}>
                      skills going help here
                    </span>{" "}
                  </p>
                  <h3>
                    Apurv Bhalerao,{" "}
                    <span className="lead-title">Senior Manager</span>
                  </h3>
                  <img
                    src="images/endorsements/ApurvBhalerao.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
              <div className="endorsements-row">
                <h2>FSE program</h2>
                <div className="endorsements-box">
                  <p>
                    "Network Full Stack Engineer program provided me the
                    platform to achieve my goals. Positively, I also got a
                    chance to work on a related project which helped me to
                    sharpen my practical skills. As we aim to expand our
                    footprint and creditability in the 5G Telco world for our
                    Infrastructure Engineering unit, I strongly believe that
                    these certifications and skills are going to help here."
                  </p>
                  <h3>
                    Malay Dave,{" "}
                    <span className="lead-title">Senior Manager</span>
                  </h3>
                  <img
                    src="images/endorsements/MalayDave.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
            <div className="endorsements-wrap">
              <div className="endorsements-row row5">
                <h2>GeneSys (Onboarding program for Japan projects)</h2>
                <div className="endorsements-box">
                  <p>
                    "Sincere thanks to the entire L&TT team for successfully
                    completing two batches of GeneSys. A lot of diligence,
                    relentless efforts went into curating and customizing the
                    training to make it unique and relevant for the diverse
                    bilinguals that we had onboarded. In addition, seamless
                    delivery in executing the training with great feedback from
                    the participants, meeting our business objectives is a
                    testimony in itself. I was particularly impressed with the
                    performance of the teams in the finale."
                  </p>
                  <h3>
                    Santosh Bhawar,{" "}
                    <span className="lead-title">Managing Director</span>
                  </h3>
                  <img
                    src="images/endorsements/SantoshBhawar.png"
                    alt=""
                    className="endorsement-pics"
                  />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default EndoresementContent;
